export default __webpack_public_path__ + "static/media/icaew_background_l2.af25eaf1.jpg";